import { useNavigate } from 'react-router-dom';
import { useFetch } from "../../hooks/useFetch";
import { Loading, EmptyState } from "../../components/States";
import { PageHeader } from "../../components/PageHeader";
import { AlertTriangle, AlertCircle, Info, ArrowRight, CheckCircle2 } from "lucide-react";

const ICON = { danger: AlertTriangle, warning: AlertCircle, info: Info };
const STYLE = {
  danger: "border-rose-500/30 bg-rose-500/5",
  warning: "border-amber-500/30 bg-amber-500/5",
  info: "border-sky-500/30 bg-sky-500/5",
};
const ICON_COLOR = { danger: "text-rose-400", warning: "text-amber-400", info: "text-sky-400" };

export default function Operations() {
  const navigate = useNavigate();
  const { data, loading } = useFetch("/dashboard/office");
  if (loading || !data) return <Loading label="Loading work queue" />;

  return (
    <div className="space-y-8">
      <PageHeader
        eyebrow="Operations Dispatch"
        title="Needs Attention"
        subtitle={`${data.count} items in your queue, sorted by urgency. Each has a clear next action.`}
      />
      {data.count === 0 ? (
        <EmptyState title="All clear" subtitle="Nothing needs attention right now." icon={CheckCircle2} />
      ) : (
        <div className="space-y-3">
          {data.queue.map((item, idx) => {
            const Icon = ICON[item.severity] || Info;
            return (
              <div
                key={item.id + idx}
                className={`flex items-center justify-between gap-4 rounded-2xl border p-5 hw-rise ${STYLE[item.severity]}`}
                data-testid={`queue-item-${idx}`}
              >
                <div className="flex min-w-0 items-center gap-4">
                  <Icon size={22} className={`shrink-0 ${ICON_COLOR[item.severity]}`} />
                  <div className="min-w-0">
                    <div className="hw-eyebrow">{item.type}</div>
                    <div className="mt-0.5 truncate font-semibold text-white">{item.title}</div>
                  </div>
                </div>
                <button onClick={() => navigate(item.type === 'invoice' ? '/app/money' : item.type === 'estimate' ? '/app/sales' : '/app/desk')} className="flex shrink-0 items-center gap-2 rounded-lg border border-cyan-500/30 px-3 py-2 text-sm font-medium text-cyan-300 hover:bg-cyan-500/10" data-testid={`queue-action-${idx}`}>
                  <span className="hidden sm:inline">{item.action}</span>
                  <ArrowRight size={16} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
